import { IEventReportDetails } from "entities/EventReports/EventReportsEntityInterfaces";

export interface IExpandedDowntimeDetailsRow {
    start_date: Date;
    shift: string;
    valid_time: number;
    shift_info: {
        start_time: string;
        end_time: string;
        shift: {
            shift_id: number;
            name: string;
            default_day_translations?: {
                default_day_translation_id: number;
                language: {
                    language_id: number;
                    name: string;
                };
                translated_name: string;
            }[];
        };
        shift_days: {
            day: {
                day_id: number;
                name: string;
                default_day_translations?: {
                    default_day_translation_id: number;
                    language: {
                        language_id: number;
                        name: string;
                    };
                    translated_name: string;
                }[];
            };
            is_enabled: boolean;
        }[];
    };
}

export interface IDetailsReportRow {
    event_information: IEventReportDetails;
    date_stop: Date;
    time_stop: string;
    shift?: string;
    shift_info?: {
        start_time: string;
        end_time: string;
        shift: {
            shift_id: number;
            name: string;
            default_day_translations?: {
                default_day_translation_id: number;
                language: {
                    language_id: number;
                    name: string;
                };
                translated_name: string;
            }[];
        };
        shift_days: {
            day: {
                day_id: number;
                name: string;
                default_day_translations?: {
                    default_day_translation_id: number;
                    language: {
                        language_id: number;
                        name: string;
                    };
                    translated_name: string;
                }[];
            };
            is_enabled: boolean;
        }[];
    };
    duration_in_minutes: number | string;
    production_line: string;
    machine_center: string;
    functional_location?: string;
    area?: string;
    failure_type: string;
    failure_code?: string;
    rca_triggered: string;
    operator: string;
    notes: string | null;
    expandedData?: IExpandedDowntimeDetailsRow[];
    multiple_shifts: boolean;
    multiple_shifts_names: string;
}

export enum DetailsReportColumnsIdEnum {
    DATE_STOP = "date_stop",
    TIME_STOP = "time_stop",
    DURATION = "duration_in_minutes",
    SHIFT = "shift",
    PRODUCTION_LINE = "production_line",
    MACHINE_CENTER = "machine_center",
    FUNCTIONAL_LOCATION = "functional_location",
    AREA = "area",
    FAILURE_TYPE = "failure_type",
    FAILURE_CODE = "failure_code",
    RCA = "rca_triggered",
    OPERATOR = "operator",
    COMMENTS = "notes",
    EDITION_OPTIONS = "edition_options",
}

export interface IEditionEventDetails {
    edit: boolean;
    id: number;
    changes?: {
        edited_by_user_id?: number;
        functional_location_id?: number;
        failure_type_id?: number;
        failure_code_id?: number;
        notes?: string;
        user_id?: number;
    };
}
